<template>
  <div>
    <p>Dist - {{ distanceMiles() }}&nbsp;Dur - {{ distanceHoursMinutes }}</p>
   </div>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "BookingTripETARoute",
  model: {
    prop: "content",
    event: "input",
  },
  components: {},
  props: {
    bookingForm: Object,
  },
  computed: {
    distanceHoursMinutes: function () {
      if (this.bookingForm.booking.route.time == null) {
        return "";
      }

      return this.minutesToHoursMinutesString(
        this.bookingForm.booking.route.time
      );
    },
  },
  data() {
    return {};
  },
  methods: {
    distanceMiles: function () {
      if (this.bookingForm.booking.route.distance_in_miles == null) {
        return "Unknown";
      }

      return this.bookingForm.booking.route.distance_in_miles.toFixed(1) + "mi";
    },
    durationToHoursMinutesString: function (duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    minutesToHoursMinutesString: function (minutes) {
      var duration = moment.duration(minutes, "minutes");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
